// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__NHSeh","invites-tab":"styles_invites-tab__qO25T","invitesTab":"styles_invites-tab__qO25T"};